/**
 * Standard easeOutQint easing equation
 * @param time {Number} Current time
 * @param start {Number} Start value
 * @param change {Number} Total change to cover
 * @param duration {Number} Interval to apply the change over
 */
export function easeOutQuint(time, start, change, duration) {
  return change * ((time = time / duration - 1) * time * time * time * time + 1) + start
}

/**
 * Animate a given property on an element. Only works with Numeric properties
 * @param element {HTMLElement}
 * @param prop {String} The property of the element to animate
 * @param to {Number} The value of the property that should be animated to
 * @param [callback] {function} Callback to call when duration finishes or property reaches @to
 * @param [duration=500] {Number} Duration
 * @param [easing] {function} Standard easing function with signature of (time, start, change, duration)
 */
export default function animateProperty(
  element,
  prop,
  to,
  callback,
  duration = 500,
  easing = easeOutQuint
) {
  const start = element[prop]
  const change = to - start
  const increment = 20
  let currentTime = 0

  const animate = () => {
    currentTime += increment

    const target = easing(currentTime, start, change, duration)

    if (currentTime >= duration || Math.abs(to - target) <= to * 0.00001) {
      element[prop] = to
      if (callback && typeof callback === 'function') {
        window.requestAnimationFrame(callback)
      }
    } else {
      element[prop] = target
      window.requestAnimationFrame(animate)
    }
  }
  // Because we just read a property that might have caused reflow, wait before animating first step
  window.requestAnimationFrame(animate)
}
